// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"jQ-z","categoryName":"kQ-z","categoryNameSearchHeader":"lQ-z","categoryContent":"mQ-z","bottomAligned":"nQ-z","image":"oQ-z","imageNoBackground":"pQ-z"};